"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.claimAirdropTxb = claimAirdropTxb;
const transactions_1 = require("@mysten/sui/transactions");
const alphafi_sdk_1 = require("@alphafi/alphafi-sdk");
async function claimAirdropTxb(options, ignoreCache) {
    const txb = new transactions_1.Transaction();
    const receipt = await (0, alphafi_sdk_1.getReceipts)("ALPHA", options.address, ignoreCache);
    if (receipt.length > 0) {
        txb.moveCall({
            target: `${(0, alphafi_sdk_1.getConf)().ALPHA_LATEST_PACKAGE_ID}::alphapool::claim_airdrop`,
            typeArguments: [alphafi_sdk_1.coinsList["ALPHA"].type],
            arguments: [
                txb.object((0, alphafi_sdk_1.getConf)().VERSION),
                txb.object(receipt[0].objectId),
                txb.object((0, alphafi_sdk_1.getConf)().ALPHA_POOL),
                txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
            ],
        });
        return txb;
    }
    else {
        throw new Error("no receipt!!!!");
    }
}
//# sourceMappingURL=airdrop.js.map